import React, {FC} from "react";
import {MyIcon} from "@components/AppIcon";
import "./index.scss";

interface NumberKeyboardProps {
  onInput: (num: string) => void;
  onDelete: () => void;
  onClear: () => void;
}

const NUMBER_KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

const NumberKeyboard: FC<NumberKeyboardProps> = (props)=> {
  const { onInput, onDelete, onClear } = props;

  return (
    <div className={'num-keyboard'}>
      {
        NUMBER_KEYS.map((key)=> (
          <button type={'button'} className={'num-key'} key={key} onClick={()=> onInput(key)}>{key}</button>
        ))
      }
      <button type={'button'} className={'num-key num-key-fn'} onClick={()=> onClear()}>清空</button>
      <button type={'button'} className={'num-key'} onClick={()=> onInput('0')}>0</button>
      <button type={'button'} className={'num-key num-key-fn'} onClick={()=> onDelete()}>
        <MyIcon type={'icondel'}/>
      </button>
    </div>
  )
}

export default NumberKeyboard;
